// @flow

import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import TabRouter from '@westfieldcorp/tab-router';
import { WORLD_MARKETING } from '../../../path/worldPaths';
import marketingApi from '../../../network/api/marketingApi';
import type { MarketingTemplateTab } from '../../../types/marketingType';
import MarketingTab from './marketing/MarketingTab';

type Props = {}

type State = {
  marketingTab: MarketingTemplateTab[],
  ref: ?HTMLDivElement,
}

class Marketing extends React.Component<Props, State> {
  state: State = {
    marketingTab: [],
    ref: null,
  };

  componentDidMount() {
    marketingApi.fetch()
      .then(resp => resp.json())
      .then(json => this.setState({ marketingTab: json }));
  }

  render() {
    const tabs = this.state.marketingTab
      .sort((a, b) => a.marketingKey - b.marketingKey)
      .map(tab => ({
        label: tab.marketingTitle,
        link: `${WORLD_MARKETING}/${tab.marketingKey}`,
      }));
    return (
      <div
        ref={ref => (
          (ref && !this.state.ref) && this.setState({ ref })
        )}
        className="marketing-page"
      >
        <TabRouter
          className="marketing-header"
          titleClassName="marketing-subtitle"
          underline
          tabs={tabs}
          router={
            <Switch>
              {
                this.state.marketingTab.map(tab => (
                  <Route
                    key={tab.marketingKey}
                    path={`${WORLD_MARKETING}/${tab.marketingKey}`}
                    render={() => (<MarketingTab
                      scrollRef={this.state.ref}
                      data={tab.contents}
                    />)}
                  />))
              }
              {
                this.state.marketingTab.length > 0 && (
                  <Route
                    path="*"
                    render={() => (<MarketingTab
                      scrollRef={this.state.ref}
                      data={this.state.marketingTab[0].contents}
                    />)}
                  />)
              }

            </Switch>
          }
        />
      </div>
    );
  }
}

export default withRouter(Marketing);
